module.exports = "./dist/dmap/leaflet/layers-2x.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/layers-2x.png
// module id = 47
// module chunks = 4